<template>
  <div class="menu-wrapper" id="editorMenu" @click="hiddenAllTipsFun()">
    <!-- 一页纸 -->
    <div class="menu-item one-page" :class="{ active: autoOnePage }" @click="autoOne()">
      智能一页
    </div>

    <!-- 排序 -->
    <el-tooltip content="智能排序" popper-class="style-tooltip-popper">
      <div class="menu-item module-sort" @click="clickAutoSort">
        <i class="iconfont iconpaixu"></i>
      </div>
    </el-tooltip>

    <!-- 字体 -->
    <div class="menu-item font">
      <el-tooltip v-model="tooltipValues.font" content="字体" popper-class="style-tooltip-popper">
        <div
          class="tips-hover mySelect cursor_p pr"
          @click.stop="
            showTipsBoxFun('');
            tooltipValues.font = false;
            updateFontState(!showFontState);
          "
        >
          <div
            v-if="cvDetail.format_info.font"
            class="model f_13 ellipsis pr"
            :class="cvDetail.format_info.font ? 'ellipsis' : 'placeholder'"
          >
            <span v-if="cvDetail.format_info.font">
              {{ cvDetail.format_info.font | fontFamily(self) }}
            </span>
            <span v-else>请选择</span>
          </div>
          <i
            class="el-select__caret el-input__icon"
            :class="[showFontState ? 'el-icon-arrow-up' : 'el-icon-arrow-down']"
          ></i>
        </div>
      </el-tooltip>
      <transition name="el-zoom-in-top">
        <div
          v-if="showFontState"
          class="fontList pa"
          :class="{ 'en-font-list': cvDetail.basic_info.lang === 'en' }"
        >
          <template v-for="item in userFontFamily[cvDetail.basic_info.lang]">
            <div
              v-if="item.hasFont"
              class="font f_14 color_60"
              :class="[item.id === font ? 'color_red' : '']"
              :key="item.id"
              @click.stop="toggleFont(cvDetail.basic_info.lang, item)"
            >
              <span :class="['iconfont', item.iconfont]"></span>
              <img
                src="https://logo.wondercv.com/banners/OhqGtgp8NRmSYY7.svg"
                class="is-vip-icon"
                v-if="item.isVip"
              />
            </div>
            <el-tooltip
              v-else
              :key="item.id + '-tooltip'"
              class="item"
              effect="dark"
              placement="right"
            >
              <div slot="content">系统中暂无此字体<br />字体效果下载简历生效</div>
              <div
                class="font f_14 color_60"
                :class="[item.id === font ? 'color_red' : '']"
                @click.stop="toggleFont(cvDetail.basic_info.lang, item)"
              >
                <span :class="['iconfont', item.iconfont]"></span>
                <img
                  src="https://logo.wondercv.com/banners/OhqGtgp8NRmSYY7.svg"
                  class="is-vip-icon"
                  v-if="item.isVip"
                />
              </div>
            </el-tooltip>
          </template>
        </div>
      </transition>
    </div>

    <!-- 字号 -->
    <el-tooltip
      v-model="tooltipValues.font_size"
      content="字号"
      popper-class="style-tooltip-popper"
    >
      <div class="menu-item size">
        <el-select
          v-model="cvDetail.format_info.font_size"
          placeholder="请选择"
          popper-class="resume-style-popper"
          @change="changeFontSize"
          @visible-change="hiddenAllTipsFun"
        >
          <el-option
            v-for="item in FONT_SIZE"
            :class="{
              color_red: item.slice(0, 2) === cvDetail.format_info.font_size,
            }"
            :key="item"
            :value="item"
            :label="item"
          >
          </el-option>
        </el-select>
      </div>
    </el-tooltip>

    <!-- 行距 -->
    <el-tooltip
      v-model="tooltipValues.line_spacing"
      content="行距"
      popper-class="style-tooltip-popper"
    >
      <div class="menu-item line-spacing">
        <i class="menu-icon iconfont iconhangju" @click="toggleSelectFun('lineSpacingDom')"></i>
        <el-select
          v-model="cvDetail.format_info.line_spacing"
          ref="lineSpacingDom"
          placeholder="请选择"
          popper-class="resume-style-popper"
          @change="setFormatInfo({ line_spacing: cvDetail.format_info.line_spacing })"
          @visible-change="hiddenAllTipsFun()"
        >
          <el-option v-for="item in LINE_HEIGHT" :key="item" :value="item" :label="item">
          </el-option>
        </el-select>
      </div>
    </el-tooltip>

    <!-- 页边距 -->
    <el-tooltip
      v-model="tooltipValues.page_margin"
      content="页边距"
      popper-class="style-tooltip-popper"
    >
      <div class="menu-item page-margin">
        <i class="menu-icon iconfont iconyebianju" @click="toggleSelectFun('pageMarginDom')"></i>
        <el-select
          v-model="cvDetail.format_info.page_margin"
          ref="pageMarginDom"
          placeholder="请选择"
          popper-class="resume-style-popper"
          @change="setFormatInfo({ page_margin: cvDetail.format_info.page_margin })"
          @visible-change="hiddenAllTipsFun()"
        >
          <el-tooltip
            v-for="item in PAGE_PADDING"
            :key="item"
            class="item"
            effect="dark"
            content="该模版仅支持页边距5"
            :disabled="
              (cvDetail.format_info.top_format === 'left_block' && item === 5) ||
              cvDetail.format_info.top_format !== 'left_block'
            "
            popper-class="module-popper"
            placement="bottom-end"
          >
            <el-option
              :disabled="cvDetail.format_info.top_format === 'left_block' && item !== 5"
              :value="item"
              :label="item"
            >
            </el-option>
          </el-tooltip>
        </el-select>
      </div>
    </el-tooltip>

    <!-- 主题色 -->
    <div class="menu-item theme-color">
      <el-tooltip
        v-model="tooltipValues.theme"
        content="主题色"
        popper-class="style-tooltip-popper"
      >
        <div
          class="tips-hover title-color-box"
          @click.stop="
            showTipsBoxFun('titleColor');
            tooltipValues.theme = false;
          "
        >
          <div class="title-color-result">
            <div
              :style="{
                background: cvDetail.format_info.title_color,
                height: '14px',
                width: '14px',
                borderRadius: '2px',
              }"
            >
              <img
                class="pattern-img"
                src="https://logo.wondercv.com/banners/lDioR3FQgDjz06G.png"
                alt=""
              />
            </div>
          </div>
          <i
            class="el-select__caret el-input__icon"
            :class="showTipsBoxType === 'titleColor' ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
          ></i>
        </div>
      </el-tooltip>

      <transition name="el-zoom-in-top">
        <div v-if="showTipsBoxType === 'titleColor'" class="title-color-tips">
          <div class="theme-title">主题颜色</div>

          <div class="flex items-center" style="padding: 0 28px 0 18px">
            <div class="theme-color-content normal-vip">
              <div
                :class="[
                  'theme',
                  `theme-${index}`,
                  cvDetail.format_info.title_color === item &&
                  !cvDetail.format_info.title_select_color
                    ? 'action'
                    : '',
                ]"
                v-for="(item, index) in THEME"
                :key="item"
                :style="{ background: item }"
                @click="
                  setFormatInfo({
                    title_select_color: false,
                    title_color: item,
                    top_line_select_color: false,
                    top_line_color: item,
                  })
                "
              >
                <i class="iconfont iconcheck"></i>
              </div>
              <img
                class="vip-icon"
                src="https://logo.wondercv.com/banners/OhqGtgp8NRmSYY7.svg"
                alt=""
              />
            </div>
            <div class="theme-color-content wonder-vip">
              <div
                v-show="cvDetail.format_info.title_format !== 'icon'"
                :class="[
                  'theme',
                  'theme-select',
                  cvDetail.format_info.title_select_color ? 'action' : '',
                ]"
                @click.stop
              >
                <i class="iconfont iconcheck"></i>
                <input
                  type="color"
                  v-model="selectThemeColor"
                  @input="
                    debounce(() => {
                      setFormatInfo({
                        title_select_color: true,
                        title_color: selectThemeColor,
                        top_line_select_color: true,
                        top_line_color: selectThemeColor,
                      });
                    }, 300)
                  "
                />
              </div>
              <img
                class="vip-icon"
                src="https://logo.wondercv.com/banners/9rwrIGmNlvt3SIL.svg"
                alt=""
              />
            </div>
          </div>

          <div class="theme-title background-theme-title">背景样式</div>

          <div class="pattern-select-content">
            <div
              v-for="(item, index) in PATTERN_DATA"
              :key="index"
              class="pattern-item"
              :class="{
                active: cvDetail.format_info.pattern_type === item.name,
              }"
              @click="
                debounce(
                  () =>
                    setFormatInfo({
                      pattern_type: item.name,
                      pattern: item.pattern,
                    }),
                  300,
                )
              "
            >
              <i
                v-if="cvDetail.format_info.pattern_type === item.name"
                class="iconfont iconxuanzhong"
              ></i>
              <img
                v-if="item.member"
                class="vip-icon"
                src="https://logo.wondercv.com/banners/OhqGtgp8NRmSYY7.svg"
                alt=""
              />
              <img
                v-if="item.thumbnail"
                class="thumbnail-image"
                :src="item.thumbnail"
                width="66"
                height="66"
                alt=""
              />
            </div>
          </div>

          <div class="theme-title">背景位置</div>

          <div class="pattern-position-content">
            <div
              class="position-item"
              :class="{
                active: cvDetail.format_info.pattern_position === 'right',
              }"
              @click="debounce(() => setFormatInfo({ pattern_position: 'right' }))"
            >
              居右
            </div>
            <div
              class="position-item"
              :class="{
                active: cvDetail.format_info.pattern_position === 'left',
              }"
              @click="debounce(() => setFormatInfo({ pattern_position: 'left' }))"
            >
              居左
            </div>
          </div>
        </div>
      </transition>
    </div>

    <!-- 文本格式 -->
    <div class="menu-item text-format">
      <el-tooltip
        v-model="tooltipValues.text_format"
        content="文本格式"
        popper-class="style-tooltip-popper"
      >
        <div
          class="tips-hover module-box"
          @click.stop="
            showTipsBoxFun('textFormat');
            tooltipValues.text_format = false;
          "
        >
          <div class="module-result">
            <i class="iconfont iconwenbengeshi"></i>
          </div>
          <i
            class="el-select__caret el-input__icon"
            :class="showTipsBoxType === 'textFormat' ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
          ></i>
        </div>
      </el-tooltip>

      <transition name="el-zoom-in-top">
        <div v-if="showTipsBoxType === 'textFormat'" class="module-tips" @click.stop>
          <h6 class="module-tips-header">文本格式</h6>
          <div class="module-tips-content">
            <!-- 日期时间 -->
            <div class="text-format-item">
              <h6 class="text-format-item-title">日期时间</h6>
              <div class="text-format-item-list">
                <button
                  :class="[cvDetail.format_info.time_format === 'default' ? 'action' : '']"
                  @click="setFormatInfo({ time_format: 'default' })"
                >
                  <span>2021年1月</span>
                </button>
                <button
                  :class="[cvDetail.format_info.time_format === 'number' ? 'action' : '']"
                  @click="setFormatInfo({ time_format: 'number' })"
                >
                  <span>2021.01</span>
                </button>
              </div>
            </div>

            <!-- 经历标题 -->
            <div class="text-format-item">
              <h6 class="text-format-item-title">经历标题</h6>
              <div class="text-format-item-list">
                <button
                  :class="[cvDetail.format_info.body_format === 'two_line' ? 'action' : '']"
                  @click="setFormatInfo({ body_format: 'two_line' })"
                >
                  <span>双行标题</span>
                </button>
                <button
                  :class="[
                    cvDetail.format_info.body_format === 'one_line' ? 'action' : '',
                    { disabled: hasWorkSubItem },
                  ]"
                  @click="hasWorkSubItem ? null : setFormatInfo({ body_format: 'one_line' })"
                >
                  <span>单行标题</span>
                </button>
              </div>
            </div>
            <div
              class="text-format-item-radio"
              v-if="cvDetail.format_info.body_format === 'two_line'"
            >
              <cv-radio
                v-model="cvDetail.format_info.format_priority"
                :list="priorityList"
                :disabled="cvDetail.format_info.body_format === 'one_line'"
                @change="
                  body_format === 'one_line'
                    ? null
                    : setFormatInfo({
                        format_priority: cvDetail.format_info.format_priority,
                      })
                "
              />
            </div>
            <div
              class="text-format-item-radio"
              v-if="cvDetail.format_info.body_format === 'one_line'"
            >
              <cv-radio
                v-model="cvDetail.format_info.punctuation_format"
                :disabled="cvDetail.format_info.body_format === 'two_line'"
                :list="punctuation_format_list"
                @change="
                  body_format === 'two_line'
                    ? null
                    : setFormatInfo({
                        punctuation_format: cvDetail.format_info.punctuation_format,
                      })
                "
              />
            </div>
            <!-- <div class="text-format-item-radio-desc">
               同一公司添加多段职位信息时仅支持【双行标题-地点优先】样式
            </div> -->

            <!-- 简历认证 -->
            <div class="text-format-item">
              <h6 class="text-format-item-title">简历认证</h6>
              <div class="text-format-item-list special">
                <button
                  :class="[cvDetail.format_info.watermark === '' ? 'action' : '']"
                  @click="selectResumeCertification({ watermark: '' })"
                >
                  <i class="buttonicon iconfont iconbuxianshi"></i>
                  <span>不显示</span>
                </button>

                <button
                  :class="[
                    cvDetail.format_info.watermark === 'basic' ? 'action' : '',
                    cvDetail.format_info.top_format === 'left_block' ? 'disabled' : '',
                  ]"
                  :disabled="cvDetail.format_info.top_format === 'left_block'"
                  @click="selectResumeCertification({ watermark: 'basic' })"
                >
                  <i class="buttonicon iconfont iconchaojijianli"></i>
                  <span>超级简历</span>
                  <div class="hover-tooltip hover-tooltip-block">该模版不支持添加简历认证</div>
                </button>

                <button
                  :class="[
                    cvDetail.format_info.watermark === 'better' ? 'action' : '',
                    score < 80 || cvDetail.format_info.top_format === 'left_block'
                      ? 'disabled'
                      : '',
                  ]"
                  :disabled="score < 80 || cvDetail.format_info.top_format === 'left_block'"
                  @click="selectResumeCertification({ watermark: 'better' })"
                >
                  <i class="buttonicon iconfont iconyouxiujianli"></i>
                  <span>优秀简历</span>
                  <div class="hover-tooltip hover-tooltip-80">
                    {{
                      cvDetail.format_info.top_format === 'left_block'
                        ? '该模版不支持添加简历认证'
                        : '简历分数达到80分可使用此标识，请先完善简历'
                    }}
                  </div>
                </button>

                <button
                  :class="[
                    cvDetail.format_info.watermark === 'best' ? 'action' : '',
                    score < 95 || cvDetail.format_info.top_format === 'left_block'
                      ? 'disabled'
                      : '',
                  ]"
                  :disabled="score < 95 || cvDetail.format_info.top_format === 'left_block'"
                  @click="selectResumeCertification({ watermark: 'best' })"
                >
                  <i class="buttonicon iconfont icondingjianjianli"></i>
                  <span>顶尖简历</span>
                  <div class="hover-tooltip hover-tooltip-95">
                    {{
                      cvDetail.format_info.top_format === 'left_block'
                        ? '该模版不支持添加简历认证'
                        : '简历分数达到95分可使用此标识，请先完善简历'
                    }}
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <!-- 模版样式 -->
    <div class="menu-item module-add" @click.stop>
      <el-tooltip
        v-model="tooltipValues.template_style"
        content="模版样式"
        popper-class="style-tooltip-popper"
      >
        <div
          class="tips-hover module-add"
          @click.stop="
            showTipsBoxFun('templateStyle');
            tooltipValues.template_style = false;
          "
        >
          <span>模版样式</span>
          <i
            class="el-select__caret el-input__icon"
            :class="showTipsBoxType === 'templateStyle' ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
          ></i>
        </div>
      </el-tooltip>
      <transition name="el-zoom-in-top">
        <FormatChange
          v-if="showTipsBoxType === 'templateStyle'"
          @changeSaveLoading="changeSaveLoading"
        />
      </transition>
    </div>

    <!-- 模块管理 -->
    <div class="menu-item module-add" @click.stop>
      <el-tooltip
        v-model="tooltipValues.module_add"
        content="模块管理"
        popper-class="style-tooltip-popper"
      >
        <div
          class="tips-hover module-add"
          @click.stop="
            showTipsBoxFun('moduleAdd');
            tooltipValues.module_add = false;
          "
        >
          <span>模块管理</span>
          <i
            class="el-select__caret el-input__icon"
            :class="showTipsBoxType === 'moduleAdd' ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
          ></i>
        </div>
      </el-tooltip>
      <transition name="el-zoom-in-top">
        <ModuleAdd
          v-if="showTipsBoxType === 'moduleAdd'"
          @clickEditModuleName="clickEditModuleName"
          @clickDeleteModule="clickDeleteModule"
          @editItem="editItem"
          @changeSaveLoading="changeSaveLoading"
        />
      </transition>
    </div>
  </div>
</template>

<script>
import api from '@/api';
import { mapState, mapMutations, mapActions } from 'vuex';
import {
  THEME,
  HEADER_LINE_THEME,
  FONT_SIZE,
  LINE_HEIGHT,
  PAGE_PADDING,
  PATTERN_DATA,
  LETTER_DATA,
} from '@/assets/js/const';
import cvRadio from '@/components/base/cvRadio';
import ModuleAdd from './ModuleAdd.vue';
import FormatChange from './FormatChange.vue';

const getNum = (data) => {
  return data.replace(/(\d*)?\w.*/gim, '$1');
};

export default {
  props: {
    score: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      tooltipValues: {
        font: false,
        font_size: false,
        line_spacing: false,
        page_margin: false,
        theme: false,
        text_format: false,
        module_add: false,
        template_style: false,
      },
      self: this,
      THEME,
      HEADER_LINE_THEME,
      FONT_SIZE,
      LINE_HEIGHT,
      PAGE_PADDING,
      PATTERN_DATA,
      LETTER_DATA,
      autoOnePageState: false, //是否正在进行一页纸
      fontSize: '12pt',
      lineHeight: 12,
      font: '',
      padding: '',
      info: 1,
      format_pref_show_attr_name: 1,
      time_format: 'default', // 日期格式 number
      format_priority: 'time', // 时间优先
      body_format: 'two_line', // 两行标题
      punctuation_format: 'show_punctuation', // 显示分隔符
      isShowCvHeaderLine: false,
      showTipsBoxType: '', // titleColor  moreSort textFormat
      selectThemeColor: '',
      // 时间地址优先
      priorityList: [
        {
          value: 'time',
          content: '<div>时间优先</div>',
        },
        {
          value: 'city',
          content: '<div>地点优先</div>',
        },
      ],
      // 分隔符
      punctuation_format_list: [
        {
          value: 'show_punctuation',
          content: '<div>使用分隔符号</div>',
        },
        {
          value: 'not_show_punctuation',
          content: '<div>不使用分隔符号</div>',
        },
      ],
    };
  },
  components: {
    cvRadio,
    ModuleAdd,
    FormatChange,
  },
  created() {
    let {
      font,
      line_spacing,
      font_size,
      page_margin,
      time_format,
      format_priority,
      body_format,
      punctuation_format,
    } = this.cvDetail.format_info;
    this.font = font;
    this.fontSize = font_size ? `${font_size}pt` : '';

    this.lineHeight = line_spacing;
    this.padding = page_margin;
    this.time_format = time_format;
    this.format_priority = format_priority;
    this.body_format = body_format;
    this.punctuation_format = punctuation_format;
    this.format_pref_show_attr_name = this.profile.show_attr_name;

    document.addEventListener('click', () => {
      this.hiddenAllTipsFun();
    });
  },
  watch: {
    score(value, old) {
      if (value > old) return;
      if (this.cvDetail.format_info.watermark) {
        this.selectResumeCertification({
          watermark: value < 80 ? 'basic' : value > 95 ? 'best' : 'better',
        });
      }
    },
    editorMenuTipsType(newValue) {
      this.showTipsBoxType = newValue;
    },
  },
  filters: {
    fontFamily: function (value, self) {
      let { lang } = self.cvDetail.basic_info;
      return self.userFontFamily[lang].filter((item) => item.id === value)[0]?.cnName;
    },
  },
  computed: {
    ...mapState('editor', [
      'cvToken',
      'cvDetail',
      'profile',
      'autoOnePage',
      'onePageFunction',
      'hasWorkSubItem',
      'editorMenuTipsType',
    ]),
    ...mapState('experience', ['showFontState', 'userFontFamily']),
    isMentorEditor() {
      return window.location.href.includes('mentor');
    },
  },
  methods: {
    ...mapActions('editor', ['cvAutoSort', 'updateCvDetail', 'createCvDetail']),
    ...mapMutations('editor', [
      'setCvDetail',
      'setBackUpFormatInfo',
      'setProfileData',
      'setBackUpProfile',
      'setAutoOnePage',
      'setOldLineHeight',
      'setEditorMenuTipsType',
    ]),
    ...mapMutations('experience', ['updateFontState']),

    changeSaveLoading(value) {
      this.$emit('changeSaveLoading', value);
    },

    clickAutoSort() {
      const { sections_position, custom_sections_titles } = this.cvDetail?.submodule_info || {};
      if (!sections_position) return;
      for (let i = 0; i < sections_position.length; i++) {
        const type =
          sections_position[i].type === 'custom'
            ? `${sections_position[i].id}`
            : sections_position[i].type;

        const list = this.$store.state.editor[type] || [];

        const editExperience =
          Array.isArray(list) && list?.find((item) => item.id.toString().includes('edit'));

        if (editExperience) {
          const title = sections_position[i].id
            ? custom_sections_titles[`${sections_position[i].id}_title`]
            : this.cvDetail.submodule_info[`${type}_title`];
          const { name, university, company } = editExperience;

          const infoTitle = university || company || name || editExperience.title || '';

          return this.$message.error(`请先保存${title}${infoTitle ? `-${infoTitle}` : ''}后再重试`);
        }
      }
      this.cvAutoSort(true);
    },

    clickEditModuleName(item) {
      this.$emit('clickEditModuleName', item);
    },
    clickDeleteModule(item) {
      this.$emit('clickDeleteModule', item);
    },
    editItem(item) {
      this.$emit('editItem', item);
      this.hiddenAllTipsFun();
    },
    useTemplateStyleFun(item) {
      // 基本信息
      this.selectInfo(item.show_attr_name);
      // 布局
      this.setFormatInfo({ head_format: item.head_format });
      // 顶部
      this.setCvHeaderLineShow(item.top_format, item.top_format === 'line', true);
      // 标题样式
      this.changeTileFormat(item.title_format, true);
      // 主题色, 花纹
      this.setFormatInfo({
        title_select_color: false,
        title_color: item.title_color,
        top_line_color: item.top_line_color || cvDetail.format_info.top_line_color,
        top_line_select_color: false,
        pattern: item.pattern || '',
        pattern_position: item.pattern_position,
        pattern_type: item.pattern_type || 'blank',
      });
    },
    debounce(fn, timeInterval) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      let arg = [...arguments].filter((item, index) => {
        return index > 1;
      });
      this.timer = setTimeout(() => {
        fn.apply(this, arg);
      }, timeInterval);
    },
    hiddenAllTipsFun() {
      this.showTipsBoxFun('');
      this.updateFontState(false);
      Object.keys(this.tooltipValues).forEach((key) => {
        this.tooltipValues[key] = false;
      });
    },
    showTipsBoxFun(type) {
      if (type === this.showTipsBoxType) {
        this.showTipsBoxType = '';
        this.setEditorMenuTipsType(null);
      } else {
        this.showTipsBoxType = type;
        this.setEditorMenuTipsType(type);
      }
    },
    // 切换简历 标题样式（类型）
    changeTileFormat(type, isTemplateStyle) {
      if (isTemplateStyle) {
        this.setFormatInfo({ title_format: type });
      } else {
        this.setFormatInfo({ title_format: type, template_type: null });
      }
      // 如果选择了图标标题，并且这个时候标题颜色选择的自定义颜色，因为图标标题没有自定义颜色选项，所以需要把标题颜色重置为默认值
      if (type === 'icon' && this.cvDetail.format_info.title_select_color) {
        this.setFormatInfo({
          title_select_color: false,
          title_color: '#000000',
        });
      }
    },
    toggleSelectFun(type) {
      // console.log(this.$refs[type])
      this.$refs[type].toggleMenu();
    },
    // 一页纸
    autoOne() {
      //增加半秒延迟，防止重复频繁点击
      if (this.autoOnePageState) {
        return false;
      }
      this.autoOnePageState = true;
      this.onePageFunction(true);
      setTimeout(() => {
        this.autoOnePageState = false;
      }, 1000);
    },
    //切换字体
    toggleFont(lang, item) {
      this.font = item.id;
      this.setFormatInfo({ font: this.font });
      //更新下拉菜单打开状态
      this.updateFontState(false);
    },
    //更改format_info
    setFormatInfo(options) {
      //当前模块要有 key，value
      let cvDetail = JSON.parse(JSON.stringify(this.cvDetail));
      //同步数据
      Object.keys(options).forEach((key) => {
        cvDetail.format_info[key] = options[key];
        if (key === 'line_spacing') {
          //保存行距
          this.setOldLineHeight(options[key]);
        }
      });

      //同步到vuex中
      this.setCvDetail(cvDetail);

      //触发保存
      this.submit();
    },
    //修改字号
    changeFontSize() {
      this.setFormatInfo({
        font_size: getNum(this.cvDetail.format_info.font_size),
      });
    },
    // 切换是否显示信息名称
    async selectInfo(value) {
      this.profile.show_attr_name = value;
      //修改基本信息设置
      this.setProfileData({ ...this.profile });
      try {
        //检测是否有profile数据
        if (this.profile.id) {
          let res = await api.cvsEditor.editProfile(this.cvToken, this.profile);
          if (res.code === 1000) {
          } else {
            this.$message.success(res.message);
          }
        }
      } catch (error) {}
    },
    // 设置 顶部线条 显示
    async setCvHeaderLineShow(type, flag, isTemplateStyle) {
      this.isShowCvHeaderLine = flag;
      let format = {
        top_format: type,
      };

      switch (type) {
        case 'left_block':
          format.head_format = 'left';
          format.watermark = '';
          format.page_margin = 5;
          this.selectInfo(0);
          await this.updateCvDetail({
            basic_info: {
              school_logo_url: '',
            },
            operation_type: 'update_basic_info',
            skipCheck: true,
          });
          break;
        case 'left_form':
          format.title_format = 'default';
          break;
        case 'circle':
          format.head_format = 'body_center';
          break;
      }

      if (!isTemplateStyle) format.template_type = null;
      this.setFormatInfo(format);
    },
    // 保存
    async submit() {
      let { kind } = this.cvDetail.basic_info;
      if (kind === 'template' || kind === 'sample') {
        // this.$message.success('保存成功')
        //修改基本信息备份基本信息设置
        this.setBackUpProfile(JSON.parse(JSON.stringify(this.profile)));
        //修改简历设置备份
        this.setBackUpFormatInfo(JSON.parse(JSON.stringify(this.cvDetail.format_info)));
        return false;
      }
      try {
        let data = {
          operation_type: 'update_format_info',
          format_info: this.cvDetail.format_info,
        };
        let res = {};
        if (this.isMentorEditor) {
          res = await api.cvsEditor.updatedMentorCvInfo(this.cvToken, data);
        } else {
          res = await api.cvsEditor.updatedCvInfo(this.cvToken, data);
        }
        if (res.code === 1000) {
          //修改基本信息备份基本信息设置
          this.setBackUpProfile(JSON.parse(JSON.stringify(this.profile)));
          //修改简历设置备份
          this.setBackUpFormatInfo(JSON.parse(JSON.stringify(this.cvDetail.format_info)));
          //当前右侧大tab选择类型置为空
        } else {
          this.$message.success(res.message);
        }
      } catch (error) {
        this.$message.success('修改失败');
      }
    },
    async selectResumeCertification(options) {
      const scrollEl = document.querySelector('.resume-preview-wrapper');
      const firstPage = document.querySelector('.page-index-1');
      const rect = firstPage.getBoundingClientRect();
      const clientHeight = document.body.clientHeight;
      scrollEl.scrollTo({
        top: clientHeight > rect.height ? 0 : rect.height - clientHeight + 100,
        behavior: 'smooth',
      });
      //当前模块要有 key，value
      let cvDetail = JSON.parse(JSON.stringify(this.cvDetail));
      //同步数据
      Object.keys(options).forEach((key) => {
        cvDetail.format_info[key] = options[key];
        if (key === 'line_spacing') {
          //保存行距
          this.setOldLineHeight(options[key]);
        }
      });
      //同步到vuex中
      this.setCvDetail(cvDetail);

      //触发保存
      this.submit();
    },
  },
};
</script>

<style lang="scss" scoped>
@import './resumeStyleMenu.scss';
</style>
<style lang="scss">
.resume-style-popper {
  background: #1f232a;
  border-radius: 8px;
  border: 1px solid #383e49;
  backdrop-filter: blur(8px);
  margin-top: 0 !important;
  top: 46px !important;
  .el-scrollbar {
    .el-select-dropdown__item {
      color: #fff;
      &.hover {
        background-color: rgba($color: #fff, $alpha: 0.08);
      }
      &.color_red {
        color: #ff6644;
        font-weight: 500;
      }
    }
  }
  .popper__arrow {
    display: none;
  }
}
.style-tooltip-popper.is-dark {
  background: #1f232a;
  top: 32px !important;
  .popper__arrow {
    display: none;
  }
}
</style>
